import React from 'react';
import { observer } from 'mobx-react';
import { CSSTransition } from 'react-transition-group';
import mainStore from '../stores/main';
import globals from '../utils/globals';
import ButtonResponseStep from './steps/button-response-step';
//import SliderResponseStep from './steps/slider-response-step';
import InfoStep from './steps/info-step';
import EnvironmentStep from './steps/environment-step';
import ToneCalibrationIntroStep from './steps/tone-calibration-intro-step';
import ToneCalibrationPlayTestSoundStep from './steps/tone-calibration-play-test-sound-step';
import ToneCalibrationAdjustVolumeStep from './steps/tone-calibration-adjust-volume-step';
import ToneStep from './steps/tone-step';
var StepManager = observer(function (_ref) {
  var settings = _ref.settings,
    isDesktop = _ref.isDesktop;
  var test = isDesktop;
  var handleNextClick = function handleNextClick() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      points = _ref2.points,
      significantHearingLoss = _ref2.significantHearingLoss;
    mainStore.addPoints(points || 0);
    // only set significantHearingLoss if true
    // eslint-disable-next-line no-unused-expressions
    significantHearingLoss && mainStore.setHasSignificantHearingLoss();
    window.DGS.Event.getInstance().trigger('trackHearingTestNextStep', mainStore.steps[mainStore.currentStepIndex].StepViewType);
    if (mainStore.nextStepIndex) {
      mainStore.gotoStep(mainStore.nextStepIndex);
    } else {
      window.DGS.Event.getInstance().trigger('trackHearingTestResult', mainStore.points);
      var url = settings.RedirectItem;
      var lang = document.getElementsByTagName('html')[0].getAttribute('lang');
      window.location = "".concat(url, "?score=").concat(mainStore.points, "&shl=").concat(mainStore.userHasSignificantHearingLoss, "&id=").concat(settings.ConfigurationID, "&lang=").concat(lang);
    }
  };
  var handleToneChange = function handleToneChange(currentHzValue) {
    mainStore.setProgressBarStep(currentHzValue);
  };
  var stepElement = function stepElement(step) {
    var StepViewType = step.StepViewType,
      Points = step.Points;
    switch (StepViewType) {
      case globals.STEP_TYPE_BUTTON_RESPONSE:
        return /*#__PURE__*/React.createElement(ButtonResponseStep, {
          content: step,
          onNextClick: handleNextClick,
          points: Points || mainStore.defaultPoints,
          isDesktop: test
        });

      // case globals.STEP_TYPE_SLIDER_RESPONSE:
      //   return (
      //     <SliderResponseStep
      //       content={step}
      //       onNextClick={handleNextClick}
      //       points={Points || mainStore.defaultPoints}
      //     />
      //   );

      case globals.STEP_TYPE_INFO:
        return /*#__PURE__*/React.createElement(InfoStep, {
          content: step,
          onNextClick: handleNextClick
        });
      case globals.STEP_TYPE_ENVIRONMENT:
        return /*#__PURE__*/React.createElement(EnvironmentStep, {
          content: step,
          onNextClick: handleNextClick,
          points: Points || mainStore.defaultPoints
        });
      case globals.STEP_TYPE_TONE_CALIBRATION_INTRO:
        return /*#__PURE__*/React.createElement(ToneCalibrationIntroStep, {
          content: step,
          onNextClick: handleNextClick
        });
      case globals.STEP_TYPE_TONE_CALIBRATION_PLAY_TEST_SOUND:
        return /*#__PURE__*/React.createElement(ToneCalibrationPlayTestSoundStep, {
          content: step,
          onNextClick: handleNextClick
        });
      case globals.STEP_TYPE_TONE_CALIBRATION_ADJUST_VOLUME:
        return /*#__PURE__*/React.createElement(ToneCalibrationAdjustVolumeStep, {
          content: step,
          onNextClick: handleNextClick
        });
      case globals.STEP_TYPE_TONE:
        return /*#__PURE__*/React.createElement(ToneStep, {
          content: step,
          soundPaths: settings.ToneSoundPaths,
          onNextClick: handleNextClick,
          onToneChange: handleToneChange
        });
      default:
        return /*#__PURE__*/React.createElement("div", null, "Unknown StepViewType: ", StepViewType);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "step-manager"
  }, mainStore.steps.map(function (step, index) {
    return /*#__PURE__*/React.createElement(CSSTransition, {
      in: index === mainStore.currentStepIndex,
      timeout: 0,
      classNames: "step",
      unmountOnExit: true,
      key: step.Id
    }, stepElement(step));
  }));
});
export default StepManager;